import Tag from 'components/Tag';
import {Activity} from 'APIs/letrusAPI/activities/types';
import styles from './ActivityTagList.module.scss';

interface ActivityTagListProps {
  activity: Activity;
  showStartHere?: boolean;
}

function ActivityTagList({
  activity,
  showStartHere = false,
}: ActivityTagListProps) {
  const hasFocusModeTag =
    activity.activity_type === 'learning_path' && activity.uses_focus_mode;

  if (!showStartHere && activity.is_required === undefined && !hasFocusModeTag)
    return null;

  return (
    <div className={styles.tagsRow}>
      {showStartHere && (
        <Tag text="Comece por aqui!" variant="yellow" icon={['fas', 'star']} />
      )}

      {activity.is_required !== undefined && (
        <Tag
          text={activity.is_required ? 'Etapas obrigatórias' : 'Opcional'}
          variant={activity.is_required ? 'red' : 'blue'}
        />
      )}

      {hasFocusModeTag && (
        <Tag
          text="Modo Foco"
          variant="purple"
          icon={['fas', 'hourglass-start']}
        />
      )}
    </div>
  );
}

export default ActivityTagList;
